<script setup>
import { useI18n } from 'vue-i18n';
import LaisField from 'dashboard/components-next/LaisField.vue';

defineProps({
  banks: { type: Array, default: () => [] },
  errors: { type: Object, default: () => ({}) },
  participant: { type: Object, required: true },
  pixKeys: { type: Array, default: () => [] },
});

const emit = defineEmits(['update']);
const { t } = useI18n();
const optionLabel = option => option.label || option.name || option.nome;
</script>

<template>
  <div class="mt-5">
    <p class="mb-3 text-sm font-semibold text-lais-text">
      {{ t('SALES.COMMISSION.PARTICIPANTS.BANK_DETAILS') }}
    </p>
    <div class="mb-4 flex flex-wrap gap-5">
      <label class="flex items-center gap-2 text-sm text-lais-text">
        <input
          type="radio"
          value="pix"
          :checked="participant.payment_type === 'pix'"
          class="accent-lais-primary"
          @change="emit('update', 'payment_type', 'pix')"
        />
        {{ t('SALES.COMMISSION.PAYMENT_TYPES.PIX_LABEL') }}
      </label>
      <label class="flex items-center gap-2 text-sm text-lais-text">
        <input
          type="radio"
          value="banco"
          :checked="participant.payment_type === 'banco'"
          class="accent-lais-primary"
          @change="emit('update', 'payment_type', 'banco')"
        />
        {{ t('SALES.COMMISSION.PAYMENT_TYPES.BANK_LABEL') }}
      </label>
    </div>
    <div
      v-if="participant.payment_type === 'banco'"
      class="grid gap-4 md:grid-cols-3"
    >
      <LaisField :label="t('SALES.COMMISSION.FIELDS.BANK')">
        <select
          :value="participant.bank_id"
          class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
          @change="emit('update', 'bank_id', $event.target.value)"
        >
          <option value="">{{ t('SALES.COMMISSION.COMMON.SELECT') }}</option>
          <option v-for="bank in banks" :key="bank.id" :value="bank.id">
            {{ optionLabel(bank) }}
          </option>
        </select>
      </LaisField>
      <LaisField :label="t('SALES.COMMISSION.FIELDS.BRANCH')">
        <input
          :value="participant.branch"
          :placeholder="t('SALES.COMMISSION.PLACEHOLDERS.AGENCY')"
          class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
          @input="emit('update', 'branch', $event.target.value)"
        />
      </LaisField>
      <LaisField :label="t('SALES.COMMISSION.FIELDS.ACCOUNT')">
        <input
          :value="participant.account_number"
          :placeholder="t('SALES.COMMISSION.PLACEHOLDERS.ACCOUNT')"
          class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
          @input="emit('update', 'account_number', $event.target.value)"
        />
      </LaisField>
    </div>
    <div v-else class="grid gap-4 md:grid-cols-2">
      <LaisField :label="t('SALES.COMMISSION.FIELDS.PIX_KEY_TYPE')">
        <select
          :value="participant.pix_key_type"
          class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
          @change="emit('update', 'pix_key_type', $event.target.value)"
        >
          <option value="">{{ t('SALES.COMMISSION.COMMON.SELECT') }}</option>
          <option v-for="pixKey in pixKeys" :key="pixKey.id" :value="pixKey.id">
            {{ optionLabel(pixKey) }}
          </option>
        </select>
      </LaisField>
      <LaisField :label="t('SALES.COMMISSION.FIELDS.PIX_KEY')">
        <input
          :value="participant.pix_key"
          class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
          @input="emit('update', 'pix_key', $event.target.value)"
        />
      </LaisField>
    </div>
    <p v-if="errors.payment" class="mt-2 text-sm text-lais-danger">
      {{ errors.payment }}
    </p>
  </div>
</template>
